// Kosovo / Albania holiday weeks with live direct prices (GET /api/public/holiday-weeks) — shown on the Albanian-market topic pages.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { API_URL } from '../pages/admin/_shared';

export const HOLIDAY_WEEK_SLUGS = ['hotel-ulqin', 'plazhi-i-madh-ulqin', 'halal-friendly-family-hotel-ulcinj'];

const T = {
  sq: { title: 'Çmimet për javët e festave nga Kosova dhe Shqipëria', sub: 'Çmimi më i ulët direkt për 2 persona, gjysmë pension i përfshirë — i përditësuar nga kalendari ynë.', night: 'natë', nights: 'net', from: 'nga', total: 'gjithsej', request: 'me kërkesë', book: 'Rezervo', wa: 'Pyet në WhatsApp' },
  en: { title: 'Prices for the Kosovo & Albania holiday weeks', sub: 'Cheapest direct price for 2 guests, half board included — read from our live calendar.', night: 'night', nights: 'nights', from: 'from', total: 'total', request: 'on request', book: 'Book', wa: 'Ask on WhatsApp' },
  me: { title: 'Cijene za praznične sedmice iz Kosova i Albanije', sub: 'Najniža direktna cijena za 2 osobe, polupansion uključen — iz našeg kalendara uživo.', night: 'noć', nights: 'noći', from: 'od', total: 'ukupno', request: 'na upit', book: 'Rezerviši', wa: 'Pitajte na WhatsApp' },
};

export const HolidayWeeks = ({ lang, prefix }) => {
  const [data, setData] = useState(null);
  const l = T[lang] ? lang : 'en';
  const t = T[l];
  useEffect(() => {
    fetch(`${API_URL}/api/public/holiday-weeks?lang=${l}`).then((r) => r.json()).then(setData).catch(() => setData({ weeks: [] }));
  }, [l]);
  if (!data) return <div className="rounded-2xl border p-6 text-sm text-gray-500" data-testid="holiday-weeks-loading">…</div>;
  if (!data.weeks.length) return null;
  const rows = data.weeks.map((w) => (
    <li key={w.check_in} className="flex flex-wrap items-center justify-between gap-3 p-4" data-testid={`holiday-week-${w.key}-${w.check_in}`}>
      <div className="min-w-0">
        <div className="font-semibold text-gray-900">{w.name}</div>
        <div className="text-xs text-gray-500">{w.check_in} → {w.check_out} · {w.nights} {w.nights === 1 ? t.night : t.nights}</div>
      </div>
      <div className="flex items-center gap-3">
        {w.price ? (
          <div className="text-right">
            <div className="text-lg font-bold text-gray-900">{t.from} €{w.price.per_night}<span className="text-xs font-normal text-gray-500"> / {t.night}</span></div>
            <div className="text-xs text-gray-500">€{w.price.total} {t.total} · {w.price.name}</div>
          </div>
        ) : <span className="text-sm text-gray-500 italic">{t.request}</span>}
        {w.price ? (
          <Link to={`${prefix}${w.booking_path}`} className="rounded-full bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 transition-colors" data-testid={`holiday-week-book-${w.check_in}`}>{t.book}</Link>
        ) : (
          <a href={`https://wa.me/38269533984?text=${encodeURIComponent(`${w.name} ${w.check_in} – ${w.check_out}`)}`} target="_blank" rel="noreferrer" className="rounded-full border border-emerald-500 text-emerald-700 text-sm font-semibold px-4 py-2 hover:bg-emerald-50 transition-colors" data-testid={`holiday-week-wa-${w.check_in}`}>{t.wa}</a>
        )}
      </div>
    </li>
  ));
  return (
    <section className="rounded-2xl border bg-white shadow-sm" data-testid="holiday-weeks">
      <div className="p-4 border-b bg-orange-50/60">
        <h2 className="text-base md:text-lg font-bold text-gray-900 flex items-center gap-2"><CalendarDays className="w-4 h-4 text-orange-500" /> {t.title}</h2>
        <p className="text-xs text-gray-600 mt-1">{t.sub}</p>
      </div>
      <ul className="divide-y">{rows}</ul>
    </section>
  );
};
